import styles from "../styles/Home.module.scss";
import MovieActivity from "../../../public/assets/create-activity-watch-movie.svg";

export default function CreateActivitySection() {
  return (
    <div className={styles.create_activity_container}>
      <div className={styles.image_activity}>
        <MovieActivity className={styles.image}></MovieActivity>
      </div>
      <div className={styles.caption_create_btn}>
        <div className="caption-create-activity">
          <p>Find friends to join your activity</p>
        </div>
        <div className="button-container">
          <button className={styles.button_custom}>Create YOUR Activity</button>
        </div>
      </div>
    </div>
  );
}
